import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { BsCloudArrowUp } from "react-icons/bs";
import { FaArrowLeft, FaRegSave, FaTable } from "react-icons/fa";
import { MdDelete, MdMessage, MdUpload, MdArrowBack } from "react-icons/md";
import { TiTick } from "react-icons/ti";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Added getAllStaffService to your imports
import { API_ROUTES, REACT_APP_API_URL } from "../../config/api-config";
import { getAllStaffService } from "../../services/api-service"; 
import "./AddStudents.css";
import AddCamera from "./AddCamera";
import { useLocation, useHistory, useParams } from "react-router-dom";
import EditStaffDetails from "components/edit-student/indexstaff";
import EditStudentDetails from "components/edit-student/index";
import { useMemo } from "react";
import "./StudentRegistration.css";
import ImageCropper from "./AddCamera";
import "./LogoLoader.css";
import { Password } from "@mui/icons-material";
import "./LogoLoaders.css";
import AutoFaceIdCamera from "./AutoFaceIdCamera";

const StudentRegistration = () => {
  const location = useLocation();
  const students_id = location.state || {};

  const [student_id, setStudentId] = useState(students_id.student_id || "");
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [membership_start_date, setMembershipStartDate] = useState("");
  const [membership_end_date, setMembershipEndDate] = useState("");
  const [selectType, setSelectType] = useState('');
  const [area_id, setAreaId] = useState("");
  const [shift_id, setShiftId] = useState("");
  const [image, setImage] = useState("");
  const [imageName, setImageName] = useState("");
  const [saimage, setSaImage] = useState("");
  const [saimageName, setSaImageName] = useState("");
  const [email, setEmailId] = useState("");
  const [mobile_no, setMobileNumber] = useState("");
  
  // New States for Corporate Visitors
  const [whomToMeet, setWhomToMeet] = useState("");
  const [reasonToMeet, setReasonToMeet] = useState("");
  const [staffOptions, setStaffOptions] = useState([]); // State for the staff dropdown

  const [uploadImage, setUploadImage] = useState(false);
  const [capturedImages, setCapturedImages] = useState([]);
  const token = localStorage.getItem("accessToken");
  const [section, setSection] = useState("");
  const [images, setImages] = useState([]);
  const [multeImage, setMulteImage] = useState([]);
  
  const [loading, setLoading] = useState(false);

  const videoRef = useRef(null);
  const history = useHistory();

  const [allImages, setAllImages] = useState([]);

  const { student_id: editId } = useParams();
  const isEdit = Boolean(editId);

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const sessionTypes = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];

  // Fetch Staff List on Component Mount
  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const res = await getAllStaffService();
        const staffData = res.data || res || [];
        // Map data to the format react-select requires
        const options = staffData.map(staff => ({
          value: staff.staff_id,
          label: `${staff.first_name} ${staff.last_name} (${staff.department})`
        }));
        setStaffOptions(options);
      } catch (err) {
        console.error("Failed to load staff roster", err);
      }
    };
    fetchStaff();
  }, []);

  const handleMultipleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setAllImages((prev) => [...prev, ...files]);
    setMulteImage((prev) => [...prev, ...files]);
  };

  const handleImageCapture = (files) => {
    setAllImages((prev) => [...prev, files]);
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (err) => reject(err);
    });

  const handleSubmit = () => {
    setLoading(true);

    Promise.all(
      allImages.map((img) => {
        if (img instanceof File) {
          return readFileAsBase64(img);
        }
        return img;
      })
    )
      .then((images) => {
        if (images.length === 0) {
          toast.warn("Please upload at least one image");
          setLoading(false);
          return Promise.reject("No images uploaded");
        }
        if (student_id.length === 0) {
          toast.warn("Visitor ID required");
          setLoading(false);
          return Promise.reject("Visitor ID required");
        }

        const img1 = images.map((img) => img.split(",")[1]);

        if (!student_id) { toast.warn("Visitor ID is required"); return; }
        if (!first_name) { toast.warn("First name is required"); return; }
        if (!last_name) { toast.warn("Last name is required"); return; }
        if (!email) { toast.warn("Email is required"); return; }
        if (!mobile_no) { toast.warn("Contact number is required"); return; }
        if (!selectType) { toast.warn("Gender is required"); return; }

        if (!whomToMeet) { toast.warn("Whom to meet is required"); return; }
        if (!reasonToMeet) { toast.warn("Reason to meet is required"); return; }

        return fetch(`${REACT_APP_API_URL}/${API_ROUTES.add_student}`.replace(/([^:]\/)\/+/g, "$1"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            student_id,
            first_name,
            last_name,
            email,
            mobile_no,
            selectType,
            membership_start_date,
            membership_end_date,
            whom_to_meet: whomToMeet,
            reason_to_meet: reasonToMeet,
            section,
            images,
            password,
          }),
        }).then(async (res) => {
          const data = await res.json().catch(() => null);

          if (res?.status === 201) {
            toast.success("Visitor Registered Successfully");
            // Reset all fields
            setStudentId("");
            setFirstName("");
            setLastName("");
            setMembershipStartDate("");
            setMembershipEndDate("");
            setSelectType("");
            setWhomToMeet("");
            setReasonToMeet("");
            setSection("");
            setPassword("");
            setAreaId("");
            setShiftId("");
            setImage("");
            setImageName("");
            setSaImage("");
            setSaImageName("");
            setCapturedImages([]);
            setEmailId("");
            setMobileNumber("");
            setMulteImage([]);
            setAllImages([]);

            history.push("/admin/FaceDetails");
          } else {
            toast.error(data && data.detail)
          }
        });
      })
      .catch((error) => {
        console.log("error", error)
        toast.error(error)
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const removeImage = (indexToRemove) => {
    setAllImages((prev) => prev.filter((_, i) => i !== indexToRemove));
    setMulteImage((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setImage(file);
    setImageName(file.name);
  };

  // Custom styles for react-select to match your existing inputs
// Custom styles for react-select to fix the white-on-white issue
  const selectStyles = {
    control: (base) => ({
      ...base,
      border: '1px solid #d1d5db',
      borderRadius: '8px',
      padding: '4px',
      boxShadow: 'none',
      fontSize: '14px',
      '&:hover': { borderColor: '#00bcd4' }
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999
    }),
    option: (base, state) => ({
      ...base,
      color: '#000000', // Force black text
      backgroundColor: state.isSelected 
        ? '#e0f2fe' // Light blue if selected
        : state.isFocused 
          ? '#f3f4f6' // Light grey on hover
          : '#ffffff', // White by default
      cursor: 'pointer',
      '&:active': {
        backgroundColor: '#bae6fd'
      }
    }),
    singleValue: (base) => ({
      ...base,
      color: '#000000', // Force black text for the selected item
    })
  };
 return (
    <>
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      <div className="container">
        <div className="form-section">
          {/* ✅ BACK BUTTON */}
          <button 
            onClick={() => history.push("/admin/FaceDetails")}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              backgroundColor: 'transparent',
              border: 'none',
              color: '#6b7280',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: '600',
              marginBottom: '20px',
              padding: 0
            }}
          >
            <MdArrowBack size={20} />
            Back to Menu
          </button>

          <h2>Visitor Form</h2>

          <div className="form-group">
            <label className="lebcs">Visitor ID</label>
            <input
              className="Asss"
              type="text"
              value={student_id}
              onChange={(e) => setStudentId(e.target.value)}
              placeholder="Enter ID"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">First Name</label>
              <input
                className="Asss"
                type="text"
                placeholder="First Name"
                value={first_name}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label className="lebcs">Last Name</label>
              <input
                className="Asss"
                type="text"
                placeholder="Last Name"
                value={last_name}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Email</label>
              <input
                className="Asss"
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmailId(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label className="lebcs">Gender</label>
              <select
                className="Asss"
                value={selectType}
                onChange={(e) => setSelectType(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Gender
                </option>
                {sessionTypes.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Contact Details</label>
              <input
                className="Asss"
                type="tel"
                placeholder="Contact Number"
                value={mobile_no}
                onChange={(e) => setMobileNumber(e.target.value)}
              />
            </div>
          </div>

          {/* Searchable Dropdown for Corporate Visitors */}
          <div className="form-row">
            <div className="form-group" style={{ zIndex: 100 }}>
              <label className="lebcs">Whom to Meet</label>
              <Select
                isSearchable={true}
                isClearable={true}
                placeholder="Search staff name..."
                options={staffOptions}
                styles={selectStyles}
                value={staffOptions.find(option => option.label === whomToMeet) || null}
                onChange={(selectedOption) => setWhomToMeet(selectedOption ? selectedOption.label : "")}
              />
            </div>

            <div className="form-group">
              <label className="lebcs">Reason to Meet</label>
              <input
                className="Asss"
                type="text"
                placeholder="e.g. Interview, Project Discussion"
                value={reasonToMeet}
                onChange={(e) => setReasonToMeet(e.target.value)}
                required
              />
            </div>
          </div>

        </div>

        {/* --- CAMERA AND GALLERY SECTION --- */}
        <div className="camera-section">
          <h2>Live Camera</h2>
          
          <AutoFaceIdCamera onImageCapture={handleImageCapture} />
          
          <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "15px" }}>
            
            {/* Upload Button */}
            <label style={{ 
                color: '#fff', 
                backgroundColor: '#00bcd4',
                padding: '10px 20px',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontWeight: 'bold',
                boxShadow: '0 4px 10px rgba(0, 188, 212, 0.3)',
                marginBottom: '15px'
              }} 
              htmlFor="student_images"
            >
              Upload Image(s)
              <MdUpload size={20} />
              <input
                className="Asss"
                id="student_images"
                accept=".png, .jpeg, .jpg"
                style={{ display: "none" }}
                type="file"
                multiple
                onChange={handleMultipleImageChange}
              />
            </label>

            {/* Visual Gallery with Delete Buttons */}
            {allImages.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center", width: "100%" }}>
                {allImages.map((img, index) => {
                  const isFile = img instanceof File || img instanceof Blob;
                  const imgSrc = isFile ? URL.createObjectURL(img) : img;

                  return (
                    <div key={index} style={{ position: "relative", width: "70px", height: "70px" }}>
                      <img 
                        src={imgSrc} 
                        alt={`captured-face-${index}`} 
                        style={{ 
                          width: "100%", 
                          height: "100%", 
                          objectFit: "cover", 
                          borderRadius: "8px", 
                          border: "2px solid #00bcd4" 
                        }} 
                      />
                      <button
                        type="button"
                        onClick={() => removeImage(index)}
                        style={{
                          position: "absolute",
                          top: "-6px",
                          right: "-6px",
                          background: "#ff4444",
                          color: "white",
                          border: "none",
                          borderRadius: "50%",
                          width: "22px",
                          height: "22px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                          boxShadow: "0 2px 5px rgba(0,0,0,0.4)"
                        }}
                      >
                        <MdDelete size={14} />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
            
          </div>
        </div>
      </div>

      <div style={{ width: '100%', paddingLeft: '172px', paddingRight: '172px', marginTop: '20px', marginBottom: '40px' }}>
        <button className="upload-btn" onClick={handleSubmit} style={{ width: '100%' }}>
          Register Visitor
        </button>
      </div>
    </>
  );
};

export default StudentRegistration;
